import { Navigate, Outlet } from 'react-router';
import type { DashboardRole } from '@/types/session';
import { useSession } from '../sessionContext';

/**
 * Layer 3: an explicit allow-list per route, defaulting to deny.
 *
 * Never a negative test. `role !== 'SenderCustomer'` reads the same and behaves
 * completely differently the day a seventh role is added: a negative test
 * silently grants the new role everything, where an allow-list gives it nothing
 * until someone decides otherwise.
 *
 * This is UX, not security — the backend enforces the same rules independently.
 */
export function RoleGuard({ allow }: { allow: readonly DashboardRole[] }) {
  const session = useSession();

  if (!allow.includes(session.role)) {
    return <Navigate to="/not-permitted" replace />;
  }

  return <Outlet />;
}
